<template>
	<div>
		<!-- Footer -->
		<footer class="text-center text-lg-start text-muted" style="background-color: #263238">
			<!-- Section: Social media -->
			<section class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
				<!-- Left -->
				<div class="me-5 d-none d-lg-block text-info">
					<span>Get connected with us on social networks:</span>
				</div>
				<!-- Left -->

				<!-- Right -->
				<div>
					<a href="" class="me-4 text-reset hover-info">
						<i class="fab fa-facebook-f hover-info"></i>
					</a>
					<a href="" class="me-4 text-reset hover-info">
						<i class="fab fa-twitter hover-info"></i>
					</a>
					<a href="" class="me-4 text-reset hover-info">
						<i class="fab fa-google  hover-info"></i>
					</a>
					<a href="" class="me-4 text-reset hover-info">
						<i class="fab fa-instagram  hover-info"></i>
					</a>
					<a href="" class="me-4 text-reset hover-info">
						<i class="fab fa-linkedin  hover-info"></i>
					</a>
					<a href="" class="me-4 text-reset hover-info">
						<i class="fab fa-github  hover-info"></i>
					</a>
				</div>
				<!-- Right -->
			</section>
			<!-- Section: Social media -->

			<!-- Section: Links  -->
			<section class="">
				<div class="container text-center text-md-start mt-5">
					<!-- Grid row -->
					<div class="row mt-3">
						<!-- Grid column -->
						<div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
							<!-- Content -->
							<h6 class="text-uppercase fw-bold mb-4 text-info">six4three</h6>
							<p>
								We're here to help simplify running your league! Shoot us an email if you have ideas, suggestions, or found a bug.
							</p>
						</div>
						<!-- Grid column -->

						<!-- Grid column -->
						<div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
							<!-- Links -->
							<h6 class="text-uppercase fw-bold mb-4 text-info">Website</h6>
							<p>
								<a role="button" class="text-reset hover-info">About</a>
							</p>
							<p>
								<router-link to="/discussions" role="button" class="text-reset hover-info">Dugout Talk</router-link>
							</p>
							<p>
								<a role="button" class="text-reset hover-info">League Page</a>
							</p>
							<p>
								<a role="button" class="text-reset hover-info">Team Page</a>
							</p>
						</div>
						<!-- Grid column -->

						<!-- Grid column -->
						<div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
							<!-- Links -->
							<h6 class="text-uppercase fw-bold mb-4 text-info">Info</h6>
							<p>
								<a role="button" class="text-reset hover-info">Pricing</a>
							</p>
							<p>
								<a role="button" class="text-reset hover-info">Settings</a>
							</p>
							<p>
								<a role="button" class="text-reset hover-info">Orders</a>
							</p>
							<p>
								<a role="button" class="text-reset hover-info">Help</a>
							</p>
						</div>
						<!-- Grid column -->

						<!-- Grid column -->
						<div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
							<!-- Links -->
							<h6 class="text-uppercase fw-bold mb-4 text-info">Contact</h6>
							<p><i class="fas fa-home me-3 text-info"></i> Temecula, CA 92529, US</p>
							<p>
								<i class="fas fa-envelope me-3 text-info"></i>
								obrien.mcquade@gmail.com
							</p>
							<!-- <p><i class="fas fa-phone me-3"></i> + 01 234 567 88</p>
							<p><i class="fas fa-print me-3"></i> + 01 234 567 89</p> -->
						</div>
						<!-- Grid column -->
					</div>
					<!-- Grid row -->
				</div>
			</section>
			<!-- Section: Links  -->

			<!-- Copyright -->
			<div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05)">
				©  Copyright {{year}}
				<a class="text-reset fw-bold" target="_blank" href="https://obrienmcquade.com/">StacWare</a>
			</div>
			<!-- Copyright -->
		</footer>
		<!-- Footer -->
	</div>
</template>

<script>
import moment from 'moment';
moment().format();
export default {
	computed: {
		year() {
			return moment().year()
		}
	}
}
</script>

<style scoped>
a .hover-info:hover {
	color: #39C0ED !important;
}
p .hover-info:hover {
	color: #39C0ED !important;
}
</style>